;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import { z } from "zod/v4";
import { OrganizationStatus } from "@/types/organization";
import { UserRole } from "@/types/user";

export const editOrganizationSchema = z.object({
	address: z
		.string()
		.trim()
		.min(1, { error: "Organization address is required" }),
	logo: z.string().url().nullable().optional(),
	name: z.string().trim().min(1, { error: "Organization name is required" }),
	status: z.enum(OrganizationStatus),
});

export type EditOrganizationSchema = z.infer<typeof editOrganizationSchema>;

export const removeOrganizationUserSchema = z.object({
	confirmationName: z
		.string()
		.trim()
		.min(1, { error: "Confirmation name is required" }),
});

export type RemoveOrganizationUserSchema = z.infer<
	typeof removeOrganizationUserSchema
>;

const organizationPermissionFlagsSchema = z.object({
	canCreate: z.boolean(),
	canDelete: z.boolean(),
	canEdit: z.boolean(),
	canView: z.boolean(),
	resource: z.string().min(1),
});

export const editOrganizationUserSchema = z.object({
	firstName: z.string().trim().min(1, { error: "First name is required" }),
	lastName: z.string().trim().min(1, { error: "Last name is required" }),
	permissions: z.array(organizationPermissionFlagsSchema).min(1),
	role: z.enum(UserRole),
});

export type EditOrganizationUserSchema = z.infer<
	typeof editOrganizationUserSchema
>;
